var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "router-view",
    [
      _c(
        "meta-manager",
        { attrs: { "current-query-params": _vm.currentQueryParams } },
        [_vm._t("default")],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }